/**
 * @generated SignedSource<<dbd9293ea2c79ee86433f1d2f7015c2f>>
 * @relayHash 311c9dffc02e35e7b4c37a7c8b869632
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 214ce34788d14912ea301df0b8051a7f4bec4b09f0e5726604cfbef225f113c1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { DashboardsContentViewQuery } from './DashboardsContentViewQuery.graphql';

const node: PreloadableConcreteRequest<DashboardsContentViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "214ce34788d14912ea301df0b8051a7f4bec4b09f0e5726604cfbef225f113c1",
    "metadata": {},
    "name": "DashboardsContentViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
